import { bindHandlers } from './index.js';
import { loggedUserToProfile } from './login';

export function mainindex() {
  setTimeout(() => {
    loggedUserToProfile();
    bindHandlers();
  }, 100);
}
